<template>
  <div>
    <v-dialog persistent v-model="dialog" width="600">
      <v-card>
        <v-card-title>
          <span class="headline">Gestion des adresses de livraison</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="T_Libelle" :rules="T_LibelleRules" label="Libellé" required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="T_Rue" :rules="T_RueRules" label="Rue" required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="T_CodePostal" :rules="T_CPRules" label="Code postal" required></v-text-field>
              </v-col>
              <v-col cols="8">
                <v-text-field v-model="T_Localite" :rules="T_LocaliteRules" label="Localité" required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="T_Pays" :rules="T_PaysRules" label="Pays" required></v-text-field>
              </v-col>
            </v-row>
            <v-row
              ><v-col cols="12"><v-checkbox v-model="L_defaultAddress" label="Adresse par défaut" color="primary"></v-checkbox></v-col
            ></v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Annuler</v-btn>
          <v-btn color="blue darken-1" text @click="Fct_Save">Sauvegarder</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      L_id: 0,
      T_Libelle: "",
      T_LibelleRules: [v => !!v || "Le libellé est obligatoire"],
      T_Rue: "",
      T_RueRules: [v => !!v || "La rue est obligatoire"],
      T_CodePostal: "",
      T_CPRules: [v => !!v || "Le code postal est obligatoire"],
      T_Localite: "",
      T_LocaliteRules: [v => !!v || "La localité est obligatoire"],
      T_Pays: "Belgique",
      T_PaysRules: [v => !!v || "Le pays est obligatoire"],
      L_defaultAddress: 0
    };
  },
  methods: {
    show(id) {
      this.dialog = true;
      this.L_id = id;
      if (id != 0) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        this.$BackEndAPI
          .get("preferences/" + id + "/", { headers: { Authorization: T_Token } })
          .then(TO_Response => {
            if (TO_Response != null) {
              this.T_Libelle = TO_Response.data.libelle;
              this.T_Rue = TO_Response.data.address;
              this.T_CodePostal = TO_Response.data.postal_code;
              this.T_Localite = TO_Response.data.city;
              this.T_Pays = TO_Response.data.country;
              this.L_defaultAddress = TO_Response.data.default;
            }
          })
          .catch(O_Error => {
            this.$root.$children[0].IsisInfo(" Problème DB - " + O_Error.message, "error");
          });
      } else {
        this.T_Libelle = "";
        this.T_Rue = "";
        this.T_CodePostal = "";
        this.T_Localite = "";
        this.T_Pays = "Belgique";
        this.L_defaultAddress = 0;
      }
    },
    Fct_Save() {
      if (this.Fct_CheckData()) {
        let O_FormData = new FormData();
        let T_Key = "ADR_" + this.T_Libelle;
        O_FormData.append("key", T_Key);
        O_FormData.append("value", "");
        O_FormData.append("address", this.T_Rue);
        O_FormData.append("postal_code", this.T_CodePostal);
        O_FormData.append("city", this.T_Localite);
        O_FormData.append("country", this.T_Pays);
        O_FormData.append("libelle", this.T_Libelle);
        O_FormData.append("default", this.L_defaultAddress);
        if (this.L_id == 0) {
          var T_Token = "JWT " + this.$cookies.get("BackEndToken");
          this.$BackEndAPI
            .get("preferences/?key=" + T_Key, { headers: { Authorization: T_Token } })
            .then(TO_Response => {
              if (TO_Response != null) {
                var O_Data = TO_Response.data[0];
                if (O_Data != undefined) {
                  this.$root.$children[0].IsisInfo("La clé existe déjà !", "error");
                } else {
                  this.Fct_AddAdr(O_FormData);
                }
              }
            })
            .catch(O_Error => {
              this.$root.$children[0].IsisInfo("Could not save preference data" + O_Error.message, "error");
            });
        } else {
          //update record
          this.Fct_ModAdr(O_FormData);
        }
      }
    },
    Fct_CheckData() {
      if (this.T_Libelle == "") {
        this.$root.$children[0].IsisInfo("Vous devez renseigner un libellé", "error");
        return false;
      }
      if (this.T_Rue == "") {
        this.$root.$children[0].IsisInfo("Vous devez renseigner une rue", "error");
        return false;
      }
      if (this.T_CodePostal == "") {
        this.$root.$children[0].IsisInfo("Vous devez renseigner un code postal", "error");
        return false;
      }
      if (this.T_Localite == "") {
        this.$root.$children[0].IsisInfo("Vous devez renseigner une localité", "error");
        return false;
      }
      if (this.T_Pays == "") {
        this.$root.$children[0].IsisInfo("Vous devez renseigner un pays", "error");
        return false;
      }
      return true;
    },
    Fct_AddAdr(O_FormData) {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .post("preferences/", O_FormData, { headers: { Authorization: T_Token } })
        .then(O_Response => {
          if (O_Response != null) {
            this.dialog = false;
            this.$parent.Fct_GetAdr();
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Could not add preference data" + O_Error.message, "error");
        });
    },
    Fct_ModAdr(O_FormData) {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .patch("preferences/" + this.L_id + "/", O_FormData, { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.dialog = false;
            this.$parent.Fct_GetAdr();
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Could not modify preference data" + O_Error.message, "error");
        });
    }
  }
};
</script>

<style scoped></style>
